import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SessionExpirationService } from '../session-expiration.service';
import { UserState } from '../../store/user/user.state';
import { SignOut } from '../../store/user/user.actions';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router,
    private sessionExpirationService: SessionExpirationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    // return this.oktaAuthGuard.canActivate(route, state);

    if (this.store.selectSnapshot(UserState.isAuthenticated)) {
      if (this.sessionExpirationService.isSessionAlreadyExpired()) {
        console.log('401 Logging: Initiating User SignOut from auth guard service due to isSessionAlreadyExpired...');
        this.store.dispatch(new SignOut({ sessionExpired: true }));
        return false;
      }

      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}
